export default "<span [ngClass]=\"statusClass\">{{ uppercase ? (displayValue | uppercase) : displayValue }}</span>"